/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type ReportFeedbackState from '@linc-technologies/linced-common/enums/reports/report-feedback-state';
import type Person from '@linc-technologies/linced-common/models/person';
import type StudentReport from '@linc-technologies/linced-common/models/reports/student-report';
import type StudentReportSection from '@linc-technologies/linced-common/models/reports/student-report-section';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: reports.ReportFeedback.
export default class ReportFeedback extends Model {
  declare [Type]: 'reports/report-feedback';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @belongsTo('reports/student-report', { async: true, inverse: null })
  declare studentReportId: AsyncBelongsTo<StudentReport>;

  @alias('studentReportId')
  declare studentReport: AsyncBelongsTo<StudentReport>;

  @belongsTo('reports/student-report-section', { async: true, inverse: null })
  declare studentReportSectionId: AsyncBelongsTo<StudentReportSection>;

  @alias('studentReportSectionId')
  declare studentReportSection: AsyncBelongsTo<StudentReportSection>;

  @belongsTo('person', { async: true, inverse: null })
  declare authorId: AsyncBelongsTo<Person>;

  @alias('authorId')
  declare author: AsyncBelongsTo<Person>;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare comment: string;

  @attr('string', { defaultValue: '' })
  declare emoji: string;

  @attr('number', { defaultValue: 0 })
  declare state: EnumValue<typeof ReportFeedbackState>;

  @array('string')
  declare assignedTo: StatefulArray<string>;
}
